
  import { Vue, Component } from "vue-property-decorator";
  import { Settings } from "@/store/modules/SettingModule";
  import { getModule } from "vuex-module-decorators";
  import store from "@/store";

  const SettingsModule = getModule(Settings, store);

  @Component({
    name: "TheFooter"
  })
  export default class TheFooter extends Vue {
    private year = new Date().getFullYear();
    get version() {
      return SettingsModule.appVersion;
    }

    get copyright() {
      return `Copyright ${this.year}, Veterinary Information Network®, Inc.`;
    }
  }
